import Sidebar from './components/Sidebar';
import MainContent from './components/MainContent';

function App() {
  return (
    <div className="min-h-screen overflow-x-hidden md:flex">
      <Sidebar />
      <MainContent />
    </div>
  );
}

export default App;
